<template>
  <v-container>
    <v-card class="pa-3" v-if="!formalitySchema">
      <v-skeleton-loader
        class="mx-auto"
        type="table-heading, table-thead, table-tbody, table-tfoot"
      ></v-skeleton-loader>
    </v-card>
    <FormalitiesTable v-else :schema="formalitySchema" :formalities="formalities"/>
  </v-container>
</template>
<script>
// import { mapGetters, mapActions, mapMutations } from 'vuex'
// import { db, fb } from '@/api/firebase.js'
import redaApp from '../api/redaApp'
import FormalitiesTable from '@/components/FormalitiesTable.vue'
import firebaseApi from '../api/firebaseApi'
import { mapGetters } from 'vuex'
// import AccountReceivable from '@/components/AccountReceivable.vue'

export default {
  name: 'Formalities',
  components: {
    FormalitiesTable
  },
  data: () => ({
    formalities: [],
    listenerFormalities: null,
    formalitySchema: null
  }),
  mounted: function () {
    this.reset()
    redaApp.getDescribe('formalities').then((schema) => {
      this.formalitySchema = schema
    }).catch((e) => {
      console.error(e)
    })
  },
  beforeDestroy: function () {
    this.listenerFormalities()
  },
  methods: {
    reset () {
      if (this.listenerFormalities) this.listenerFormalities()
      this.listenerFormalities = firebaseApi.db.collection('formalities')
        .where('company', '==', this.getCompany.identification)
        .onSnapshot(({ docs }) => {
          this.formalities = []
          for (let i = 0; i < docs.length; i++) {
            const doc = docs[i]
            this.formalities.push({ ...doc.data(), uid: doc.id })
          }
        })
    }
  },
  computed: {
    ...mapGetters('company', [
      'getCompany'
    ])
    // ...mapGetters()
  },

  watch: {
  }
  /* created () {
  }, */
}
</script>
<style type="text/css">
</style>
